import { render, staticRenderFns } from "./MasterSalary.vue?vue&type=template&id=e692bfba"
import script from "./MasterSalary.vue?vue&type=script&lang=js"
export * from "./MasterSalary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports